// extracted by mini-css-extract-plugin
module.exports = {"price":"_2SCM5kJ9 mb1","free":"_2WTNU4bt","customization":"xVIoSooq","original-price":"_2kZ26OwS ml1","originalPrice":"_2kZ26OwS ml1"};